import HTTPService from "@/services/http_service.js";

export default class ObitoService extends HTTPService {
  resource = "obito";

  static build() {
    return new ObitoService();
  }

  procedimentosObitoUnidade(unidadeId) {
    const model = {
      id_unidade: unidadeId,

    };
    return this.postJson(`${this.resource}/procedimento/list`, model);
  }

  requisitarObito(model) {
    // {
    //   "id_pet": "17",
    //   "id_convenio_procedimento": "104437",
    //   "status_id": "7",
    // "obito": "s"
    //   "data_execucao": "01-01-2025",
    //   "hora_execucao": "16:23",
    //   "id_unidade": "30",
    //   "observacao": " ",
    //   }
    return this.postJson(`${this.resource}/registro`, model);
  }

  deletarObito(requisicaoId, id_pet) {
    const model = {
      id_requisicao: requisicaoId,
      pet_id: id_pet,
    };
    return this.deleteJson(`${this.resource}/delete`, model);
    // return this.postJson(`${this.resource}/delete`, model);
  }

  getObitoPaginatedList({ page, per_page }) {
    return this.get(`${this.resource}/list`, {
      page,
      per_page,
    });
  }
  getObitoByPetId(petId) {
    return this.get(`pet/${this.resource}/${petId}`)
  }



  ObitoListagem(dataInicial, dataFinal, unidade, id_procedimento) {
    const requestBody = {
      dataInicial,
      dataFinal,
      unidade,
      id_procedimento,
    };

    return this.post(
        "obito/list",
        requestBody,
        {
          responseType: "json",
        }
    )}}
